"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const auto_complete_input_module_css_1 = __importDefault(require("./auto-complete-input.module.css"));
const AutoCompleteInput = ({ value, onChange, suggestions }) => {
    const [isDatalistOpen, setDatalistOpen] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleInputChange = (e) => {
        const trimmedValue = e.target.value.trim();
        onChange(trimmedValue);
        setDatalistOpen(true);
    };
    const handleSuggestionClick = (suggestion) => {
        onChange(suggestion);
        setDatalistOpen(false);
    };
    const handleClickOutside = (e) => {
        if (inputRef.current && !inputRef.current.contains(e.target)) {
            setDatalistOpen(false);
        }
    };
    const handleTabPress = (e) => {
        if (e.key === 'Tab') {
            setDatalistOpen(false);
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const handleClick = (e) => {
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                setDatalistOpen(false);
            }
        };
        if (inputRef.current) {
            inputRef.current.addEventListener('click', handleClick);
        }
        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener('click', handleClick);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (value && suggestions.includes(value)) {
            setDatalistOpen(false);
        }
    }, [value, suggestions]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { value: value, onChange: handleInputChange, onFocus: () => setDatalistOpen(true), onKeyDown: handleTabPress, className: auto_complete_input_module_css_1.default.input, ref: inputRef, type: "text", placeholder: t('common.placeholder-type') }), (isDatalistOpen && value.length >= 1 && suggestions.length > 0) && ((0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: auto_complete_input_module_css_1.default.list, children: suggestions.map((suggestion, index) => ((0, jsx_runtime_1.jsx)(de_ui_1.Div, { onClick: () => handleSuggestionClick(suggestion), className: auto_complete_input_module_css_1.default.div, children: suggestion }, index))) }))] }));
};
exports.AutoCompleteInput = AutoCompleteInput;
